<div #topBarContainer class="top-bar-message" [class.wide]="isProductRequest"
  [pTooltip]="userTextKey | translate: translationParams"
  tooltipPosition="left">
  <span #messageContainer [innerHTML]="messageTextKey | translate: translationParams"></span>
</div>
